import { parseRequestError } from '@/app/common/utilities'
import { useToast } from '@/shad/ui/toast/use-toast'
import { useQuery } from '@tanstack/react-query'
import { DistributionPlanSchema } from './schema'
import { getDistributionPlanPreview } from './USE_WITH_CAUTION.api'

interface UseDistributionPreviewParams {
  programId: number
  purseId: number
  enabled?: boolean
}

export function useDistributionPreview({
  programId,
  purseId,
  enabled = true,
}: UseDistributionPreviewParams) {
  const { toast } = useToast()

  return useQuery({
    queryKey: ['distribution-preview', programId, purseId],
    staleTime: 0,
    queryFn: async () => {
      try {
        const response = await getDistributionPlanPreview({
          program_id: programId,
          program_purse_id: purseId,
          distribution_strategy: 'single',
        })

        const parseResult = DistributionPlanSchema.safeParse(response)

        if (!parseResult.success) {
          console.warn('Failed to parse distribution plan:', parseResult.error)
          throw new Error('Invalid distribution plan format')
        }
        console.log(parseResult.data)

        return parseResult.data
      } catch (error) {
        const parsedError = parseRequestError(error)
        toast({
          title: 'Preview Error',
          variant: 'destructive',
          description:
            parsedError.message ||
            'Unable to load distribution preview. Please try again.',
        })
        throw error
      }
    },
    enabled,
    retry: (failureCount, error) => {
      // Don't retry if it's a parsing error
      if (error?.message === 'Invalid distribution plan format') {
        return false
      }
      return failureCount < 3
    },
  })
}
